import styled from "@emotion/styled";
import { css } from "@mui/material";
import { mobile } from "commons/styled.components";

/* Surveys hub (tabs) */

const BRAND_GREEN = "#158A73";

export const SurveysHubWrapper = styled.div<{ fullBleed: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${(props) =>
    props.fullBleed &&
    css`
      height: calc(100vh - 72px);
      height: calc(100dvh - 72px);
      overflow: hidden;
    `}
`;

export const SurveysHubTabBar = styled.div`
  flex-shrink: 0;
  padding: 16px 1.8rem;
  background: #ffffff;
  border-bottom: 1px solid #ececec;

  ${mobile(css`
    padding: 12px 1rem;
  `)}
`;

export const SurveysHubTabTrack = styled.div`
  display: flex;
  width: 100%;
  border-radius: 6px;
  border: 1px solid #e2e2e2;
  background: #f3f4f4;
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const SurveysHubTabButton = styled.button<{ isActive: boolean }>`
  flex: 1 1 0;
  min-width: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px 20px;
  border: none;
  outline: none;
  font-family: inherit;
  font-size: 1.05rem;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  color: ${(props) => (props.isActive ? "#ffffff" : "#4b4b4b")};
  background: ${(props) => (props.isActive ? BRAND_GREEN : "transparent")};
  transition:
    background 0.2s ease,
    color 0.2s ease;

  & + & {
    border-left: 1px solid #e2e2e2;
  }

  svg {
    font-size: 1.35rem;
  }

  :hover {
    color: ${(props) => (props.isActive ? "#ffffff" : "#000000")};
    background: ${(props) => (props.isActive ? BRAND_GREEN : "#e9ecea")};
  }

  :focus-visible {
    box-shadow: inset 0 0 0 3px rgba(255, 255, 255, 0.6);
  }

  ${mobile(css`
    min-width: 0;
    gap: 6px;
    padding: 10px 8px;
    font-size: 0.92rem;

    svg {
      font-size: 1.15rem;
    }
  `)}
`;

export const SurveysHubTabText = styled.span`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
  line-height: 1.25;
`;

export const SurveysHubTabLabel = styled.span`
  font-size: inherit;
  font-weight: 600;
`;

export const SurveysHubTabSubtitle = styled.span`
  font-size: 0.75rem;
  font-weight: 500;
  opacity: 0.8;

  ${mobile(css`
    font-size: 0.68rem;
  `)}
`;

export const SurveysHubTabPanel = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;
